import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  () => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '10px',
      padding: '60px 55px 30px 55px',
    },
    sectionBox: {
      border: '1px solid #eeeeee',
      borderRadius: '5px',
      padding: '20px',
      width: '100%',
      '& tr': {
        borderBottom: 'none !important',
      },
      '& td': {
        borderBottom: 'none !important',
      },
    },
    }),
  { name: 'HeaderButtons' },
); 

export default useStyles;
